var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xm-breadcrumb"},[_c('el-breadcrumb',{attrs:{"separator":">","separator-class":"el-icon-arrow-right"}},_vm._l((_vm.menus),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":{ path: item.url }}},[_vm._v(_vm._s(item.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }